import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceTypeAppResource from "./WorkspaceTypeAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";

export const HOME_PURCHASE_STATUS = {
    lead: 'c163f62b-2fc5-4964-8495-a41489b1a477',
    prospect: '3702a73f-f062-451c-af6c-43dfaa64342f',
    client: 'bcd32836-c3bf-48e6-8c0d-13807377c1e1',
    'under-contract': '402e2597-13be-493b-90ee-8df3e9977e89',
    closed: '0b28e348-8a47-4b36-ba48-294a79ec8cec',
    inactive: '1a5e2500-d02f-42c5-8a5c-08a253d6ce62',
};

export const HOME_SALE_STATUS = {
    lead: 'cbde7300-5c23-4216-ab6e-d8de4536d785',
    prospect: '4ec038d6-004d-478e-9ebb-832fda34a543',
    client: '1bd55732-9f79-4c70-acf6-3c9348d922fa',
    'under-contract': 'e40afd10-d29a-4203-a9de-7da6f6014515',
    closed: 'c978fb39-7c06-4bae-94cb-e8ebfdd06bdb',
    inactive: '8c7775d3-e99a-4db5-bbfd-335d9b0b4bfc',
};

export const MORTGAGE_STATUS = {
    lead: 'f5bbc1ee-696a-4c5c-9d8b-e05768848fbf',
    prospect: '8822ef3a-dd7d-415d-b73a-cf016ea43926',
    applied: '1e03e890-8490-40e8-8666-796188519c09',
    'processing-underwriting': '8b054a92-d1f4-4ffa-9239-4436f887a159',
    funded: '05064ea5-bf09-44fe-bcb6-c5c708bc32d8',
    inactive: 'a415a0e8-52c6-4196-a912-564296c400bd',
};

export const REFINANCE_STATUS = {
    lead: '23ce368c-f19b-4706-b43a-05fcd6af9e44',
    prospect: '00e40d7a-b0b4-4881-9b27-6e5e08a50ee5',
    applied: 'eae5bf90-6f1c-4053-9cd5-a93989d517a1',
    'processing-underwriting': '855cb8a0-feb3-415b-b559-d33efed77abf',
    funded: 'd8d17b7e-a97f-4bc6-85d3-198e7e0aaad4',
    inactive: 'a65a5c54-0f0c-401b-850b-d3b0328c5186',
};

export const REVERSE_MORTGAGE_STATUS = {
    lead: '5e4cfe8c-a908-4411-a80f-cb1fc603cfe3',
    prospect: 'd7b9c086-ff22-46e4-a459-e2692ca4148a',
    'completed-counselling': '0220bfde-22b5-4475-b40f-943b4746f4b3',
    applied: 'e9b535f0-0d12-465b-8a4d-aec4e2c3c6eb',
    'processing-underwriting': '8ada2ce9-35b4-4a3e-ae71-f0d239323f5c',
    funded: 'd01249b5-8f8c-4db5-b4af-2f94e8f2312a',
    inactive: 'e033696b-9e94-4828-a562-35344ea3f0ed',
};

class LuWorkspacePipelineStatusAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-workspace-pipeline-status';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/workspaces/pipelines/statuses';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
            'sort',
            'meta',
            'workspaceTypeUuid',
            'workspaceType',
            'workspaces',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspaceType: WorkspaceTypeAppResource,
            workspaces: WorkspaceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspaceType: 'workspace_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            sort: {
                numericality: true,
                presence: true,
            },
            meta: {
                type: 'array',
            },
            workspaceTypeUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default LuWorkspacePipelineStatusAppResource;
